<script>
  export let buttonValue = null;
  export let buttonFunction;
  export let onClick = null
  export let buttonText = "";
  export let buttonExtraStyle = "";
  export let buttonDisabled = false;
  export let buttonType = "primary"; // secondary or negative

  /**
   * @type {"small"|"medium"|"large"}
   */
  export let buttonSize = "medium"
</script>

<button
  class={buttonType}
  class:small={buttonSize === "small"}
  class:medium={buttonSize === "medium"}
  class:large={buttonSize === "large"}
  on:click={buttonFunction ?? onClick}
  value={buttonValue}
  style={buttonExtraStyle}
  disabled={buttonDisabled}
>
  {#if buttonText}
    {buttonText}
  {:else}
    <slot/>
  {/if}
</button>

<style>
  button {
    text-wrap: nowrap;
    white-space: nowrap;
  }

  /* base */
  button:hover {
    filter: brightness(0.9);
    cursor: pointer;
  }

  button:active {
    filter: brightness(0.75);
    cursor: pointer;
  }

  button:disabled {
    filter: opacity(0.3);
    cursor: default;
  }

  /* sizes */
  .small {
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
    margin: 2px 10px;
    height: 24px;
  }

  .medium {
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 14px;
    margin: 2px 10px;
    height: 30px;
  }

  .large {
    border-radius: 12px;
    padding: 12px 20px;
    font-size: 18px;
    margin: 2px 10px;
    height: 42px;
  }

  /* colors */
  .primary {
    background-color: #00468f;
    border: none;
    color: white;
  }

  .secondary {
    background-color: white;
    color: #00468f;
    border-style: solid;
    border-color: #00468f;
  }

  /* adjust padding for "secondary" as it is bordered */
  .secondary.small {
    border-width: 1px;
    padding: 4px 11px;
  }

  .secondary.medium {
    border-width: 2px;
    padding: 4px 14px;
  }

  .secondary.large {
    border-width: 3px;
    padding: 4px 17px;
  }

  .negative {
    background-color: #de5555;
    border: none;
    color: white;
  }
</style>
